(ns frontend.ui.page.lp-report-editor.common.modal.notification-email-modal
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.time :as c-time]
            [common.util :as cu]
            [frontend.state.current-session :as session]
            [frontend.tenant-customizations :as tenant-customizations]
            [frontend.ui.component.icon.style :as icon-style]
            [frontend.ui.component.label.style :as label-style]
            [frontend.ui.component.lp-portal.checkbox.view :as checkbox]
            [frontend.ui.component.modal-dialog.view :as modal-dialog]
            [frontend.ui.component.text-input.style :as input-style]
            [frontend.ui.page.lp-report-editor.common.modal.edit-text-modal :as edit-text-modal]
            [frontend.ui.page.lp-report-editor.common.modal.style :as style]
            [frontend.ui.page.lp-report-editor.common.style :as common-style]
            [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
            [frontend.ui.page.lp-report-editor.sub :as editor-sub]
            [herb.core :as h]
            [potpuri.core :as p]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.components.alert.view :as alert]
            [ui.components.button.view :as button]
            [ui.components.expansion-panel.view :as expansion-panel]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.rich-text.tiptap :as tiptap]
            [ui.dom-globals :as dg]))

(defn recipient
  [local-state email id]
  [:li
   {:class (h/<class style/recipient-list-item)}
   (cu/str-trim-lcase email)
   [:span
    {:class    (h/<class icon-style/left-padded-container)
     :on-click (fn [_]
                 (swap! local-state assoc-in [:skipped-emails id] true))}
    [:i.fal.fa-trash-alt]]])

(defn skipped-recipient
  [local-state email id]
  [:li
   {:class (h/<class style/recipient-list-item-skipped)}
   (cu/str-trim-lcase email)
   [:span
    {:class    (h/<class icon-style/left-padded-container)
     :on-click (fn [_]
                 (swap! local-state p/dissoc-in [:skipped-emails id]))}
    [:i.fal.fa-undo]]])

(defn email-recipient-list
  [recipients local-state]
  [:div
   [:label
    {:class (h/<class label-style/form-label)}
    "Choose email recipients"]
   [:ul
    {:class (h/<class style/recipient-list)}
    (->> recipients
         (map (fn [{:keys [db/id account/email]}]
                (if (get-in @local-state [:skipped-emails id])
                  ^{:key (str ::recipient "-" id)}
                  [skipped-recipient local-state email id]
                  ^{:key (str ::recipient "-" id)}
                  [recipient local-state email id])))
         (doall))]])

(defn email-message
  [local-state]
  [:div
   [:label
    {:class (h/<class label-style/form-label)}
    (loc/tr :message)]
   [:textarea
    {:class     (h/<class input-style/text-input)
     :on-change (fn [e]
                  (swap! local-state assoc :message (dg/event-target-value e)))}
    (:message @local-state)]])

(defn footnote-key-title
  [footnote-key]
  (if (keyword? footnote-key)
    (-> (name footnote-key)                                                                         ;;TODO localize all titles in the future?
        (string/replace "-footnotes" " (footnote)")
        (string/replace "-footnote" " (footnote)")
        (string/replace "-text" " (text section)")
        (string/replace "-" " ")
        (string/capitalize))
    (str footnote-key)))

(defn rich-content-list-item-text-editor
  [{:keys [rich-content]}]
  (let [current-content (r/atom rich-content)]
    (r/create-class
     {:display-name "rich-content-list-item-text-editor"
      :component-did-update
      (fn [this old-argv]
        (let [old-content (:rich-content (second old-argv))
              new-content (:rich-content (r/props this))]
          (when-not (= new-content old-content)
            (reset! current-content new-content))))
      :reagent-render
      (fn [{:keys [rich-content-completed-path rich-content rich-content-path report-id
                   local-state footnote-key on-complete-richtext!]}]
        (let [new-content @current-content
              disable-save? (or (= rich-content new-content)
                                (and (tiptap/empty-editor-value? rich-content)
                                     (tiptap/empty-editor-value? new-content)))
              rich-content-to-save (if (tiptap/empty-editor-value? new-content)
                                     ""
                                     new-content)]
          [edit-text-modal/view
           {:header                      (str "Edit " "'" (footnote-key-title footnote-key) "'")
            :on-hide!                    (fn [_]
                                           (swap! local-state assoc :show-edit-modal? false))
            :on-submit!                  (fn [_]
                                           (on-complete-richtext!
                                            report-id
                                            rich-content-path
                                            rich-content-to-save
                                            rich-content-completed-path
                                            (str (c-time/now-millis)))
                                           (swap! local-state dissoc :show-edit-modal?))
            :on-submit-edit-later!       (fn [_]
                                           (on-complete-richtext!
                                            report-id
                                            rich-content-path
                                            rich-content-to-save
                                            rich-content-completed-path
                                            "")
                                           (swap! local-state dissoc :show-edit-modal?))
            :complete-button-disabled?   disable-save?
            :edit-later-button-disabled? disable-save?}
           ^{:key "in-modal-editor"}
           [tiptap/editor
            (merge tiptap/no-align-toolbar-options
                   {:value @current-content
                    :on-change #(reset! current-content %)
                    :class "min-h-64"})]]))})))

(defn rich-content-list-item
  [_report-id _rich-content-data _on-complete-richtext!]
  (let [local-state (r/atom {:show-edit-modal? false})]
    (fn [report-id
         {:keys [footnote-key rich-content-completed-at rich-content-completed-path rich-content rich-content-path
                 completed?]}
         on-complete-richtext!]
      [:div
       {:class "font-normal"}
       (when (:show-edit-modal? @local-state)
         [rich-content-list-item-text-editor
          {:rich-content                rich-content
           :rich-content-completed-path rich-content-completed-path
           :rich-content-path           rich-content-path
           :footnote-key                footnote-key
           :report-id                   report-id
           :local-state                 local-state
           :on-complete-richtext!       on-complete-richtext!}])
       [:li [:span {:class "flex justify-between mr-2"}
             [:p (footnote-key-title footnote-key)]
             [:span
              {:class "flex gap-2 items-center justify-center"}
              (when-not (cu/blank-value? rich-content-completed-at)
                [:p
                 {:class "font-normal text-xs"}
                 (str "(" (session/long->tenant-date-time (long rich-content-completed-at)) ")")])
              [button/square-secondary-open
               {:tooltip  "Go to the editor"
                :on-click (fn [_]
                            (swap! local-state assoc-in [:show-edit-modal?] true))}
               [:i.fal.fa-edit {:class "text-md"}]]
              [tooltip/view
               {}
               [:div
                {:class "flex justify-center items-center"}
                [checkbox/checkbox
                 {:value     completed?
                  :on-change (fn [checked?]
                               (let [complete-ts (if checked?
                                                   ""
                                                   (str (c-time/now-millis)))]
                                 (on-complete-richtext! report-id
                                                        rich-content-path
                                                        (if (tiptap/empty-editor-value? rich-content)
                                                          ""
                                                          rich-content)
                                                        rich-content-completed-path
                                                        complete-ts)))}]]
               (str "Mark as " (if completed?
                                 "uncompleted"
                                 "completed"))]]]]])))

(defn rich-content-panel
  [{:keys [all-texts-completed? report-rich-content-list local-state report-id feeder? on-complete-richtext! on-complete-all!]}]
  [:div
   (when-not all-texts-completed?
     [alert/warning
      {:on-click (fn [])}
      [:div
       {:class-name "flex gap-2 items-center"}
       [:strong
        {:class-name "block"}
        "You have uncompleted footnotes or text sections. Please complete them to proceed."]]])
   [:div {:class (h/<class style/rich-content-list)}
    [expansion-panel/view
     {:label        "Edit the complete status of footnotes/text sections"
      :expanded?    (:expanded? @local-state)
      :on-expand!   (fn []
                      (swap! local-state assoc :expanded? true))
      :on-collapse! (fn []
                      (swap! local-state assoc :expanded? false))
      :opts         {:show-borders? false}}
     [:div
      {:class "flex flex-col justify-end"}
      [:div
       {:class "flex justify-between items-end mr-2 mb-2 pb-2 border-solid border-0 border-b border-[#D9D9DA]"}
       [:label
        {:class "font-bold"}
        "Title"]
       [button/helper-button
        {:tooltip   "Complete all"
         :disabled? all-texts-completed?
         :on-click  (fn [_]
                      (on-complete-all! report-id feeder?))}
        [:span "Mark all as completed" [:i.fal.fa-check {:class "text-md"}]]]]
      [:ul
       {:class "h-56 overflow-y-auto"}
       (->> report-rich-content-list
            (map (fn [rich-content-data]
                   ^{:key (str (:footnote-key rich-content-data))}
                   [rich-content-list-item report-id rich-content-data on-complete-richtext!]))
            (doall))]]]]])

(defn modal-footer
  [{:keys [on-hide! on-submit! on-skip-email! all-texts-completed? filtered-recipients local-state submit-txt]}]
  [:div
   {:class (h/<class common-style/footer-right)}
   [button/secondary-hollow
    {:on-click on-hide!}
    (loc/tr :close)]
   [:div
    [button/warning-solid
     {:on-click  (fn [_]
                   (on-skip-email!))
      :disabled? (and (not all-texts-completed?)
                      (tenant-customizations/capman?))}
     (loc/tr :skip-email?)]]
   [:div

    [button/primary-solid
     {:disabled? (or
                  (and (not all-texts-completed?)
                       (tenant-customizations/capman?))
                  (not filtered-recipients))
      :on-click  (fn [_]
                   (on-submit! (->> filtered-recipients
                                    (map :account/email)
                                    (map cu/str-trim-lcase)
                                    (seq))
                               (:message @local-state)))}
     (or submit-txt
         (loc/tr :submit))]]])

(defn view
  [{:keys [_on-hide! _on-complete-richtext! _on-complete-all! _header _recipients _report-rich-content-list _holding-report-id _submit-txt _on-submit! _on-skip-email! _feeder?]}]
  (let [local-state (r/atom {:expanded false})]
    (fn [{:keys [on-hide! on-complete-richtext! on-complete-all! header recipients report-rich-content-list holding-report-id submit-txt on-submit! on-skip-email! feeder?]}]
      (let [filtered-recipients (->> recipients
                                     (remove (fn [{:keys [db/id]}]
                                               (get-in @local-state [:skipped-emails id])))
                                     (seq))
            report-id (cond
                        holding-report-id
                        holding-report-id
                        feeder?
                        (:db/id (first @(rf/subscribe [::editor-sub/feeder-reports])))
                        :else
                        @(rf/subscribe [::sub/fund-text-submitted?]))
            all-texts-completed? (->> report-rich-content-list
                                      (every? :completed?))]
        [modal-dialog/modal-dialog
         {:visible?     true
          :hide!        on-hide!
          :header-label (or header
                            (loc/tr :email-notification))
          :size         :sm}
         [:div
          {:class (h/<class style/body)}
          (when (and (fn? on-complete-richtext!)
                     (tenant-customizations/capman?))
            [rich-content-panel
             {:all-texts-completed?     all-texts-completed?
              :report-rich-content-list report-rich-content-list
              :local-state              local-state
              :report-id                report-id
              :feeder?                  feeder?
              :on-complete-richtext!    on-complete-richtext!
              :on-complete-all!         on-complete-all!}])
          [email-recipient-list recipients local-state]
          [email-message local-state]]
         [modal-footer
          {:on-hide!             on-hide!
           :on-submit!           on-submit!
           :on-skip-email!       on-skip-email!
           :all-texts-completed? all-texts-completed?
           :filtered-recipients  filtered-recipients
           :local-state          local-state
           :submit-txt           submit-txt}]]))))
